import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { ELEVES_VIEWS_KEY } from '@teetsh/app/src/queries/eleves/views/useElevesViews';

function deleteEleveView(props: {
  schoolyearId: string;
  schoolId: string;
  viewId: string;
}) {
  const requestURL = `/schoolyears/${props.schoolyearId}/schools/${props.schoolId}/eleves-views/${props.viewId}`;
  return request(requestURL, {
    method: 'DELETE',
  });
}

export function useDeleteElevesView() {
  const { schoolyear, school } = useSchoolSchoolyear();
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation({
    mutationFn: (p: { viewId: string }) =>
      deleteEleveView({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        viewId: p.viewId,
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ELEVES_VIEWS_KEY],
      });
    },
  });
  return mutateAsync;
}
